import React from 'react';
import { Box, Container } from '@mui/material';
const defaultAdImage = 'https://images.exicube.com/uploads/ad_banner.png';

const Advertisement = ({ image, link = 'https://exicube.com?utm_source=demo_codecanyon&utm_medium=demo_banner&utm_campaign=demo_refer_banner&utm_content=exicube_cc_web_banner' }) => {
    const displayImage = image || defaultAdImage;

    return (
        <Box sx={{ py: { xs: 2, md: 4 } }}>
            <Container maxWidth="lg">
                <Box
                    onClick={() => window.open(link, '_blank')}
                    sx={{
                        width: '100%',
                        aspectRatio: '4 / 1',
                        backgroundImage: `url(${displayImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        position: 'relative',
                        overflow: 'hidden',
                        borderRadius: '24px',
                        boxShadow: '0 20px 50px rgba(0,0,0,0.2)',
                        animation: 'float 6s ease-in-out infinite',
                        cursor: 'pointer',
                        transition: 'transform 0.3s ease',
                        '&:hover': {
                            transform: 'scale(1.02)',
                        },
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: '-100%',
                            width: '60%',
                            height: '100%',
                            background: 'linear-gradient(to right, transparent, rgba(255,255,255,0.4), rgba(255,255,255,0.6), rgba(255,255,255,0.4), transparent)',
                            transform: 'skewX(-25deg)',
                            animation: 'shimmer 2.5s infinite',
                        },
                        '@keyframes shimmer': {
                            '0%': { left: '-100%' },
                            '100%': { left: '150%' }
                        },
                        '@keyframes float': {
                            '0%, 100%': { transform: 'translateY(0)' },
                            '50%': { transform: 'translateY(-10px)' }
                        }
                    }}
                />
            </Container>
        </Box>
    );
};

export default Advertisement;
